import { DateTime } from "luxon";

/**
 * react-datepicker reads a native Date in the browser's zone. A DateTime in another
 * zone (the coach's, or one whose rules the browser has out of date, CN-2932) can
 * fall on another calendar day there, so the picker would select the day before the
 * one the input shows. Build the Date from the wall-clock fields, not from the
 * instant. The time of day stays too: the picker copies it into the next day the
 * user picks (for example 23:59:59 on an end date).
 */
export const toPickerDate = (date: DateTime): Date =>
  new Date(date.year, date.month - 1, date.day, date.hour, date.minute, date.second, date.millisecond);
